<template>
  <div class="app-container">
    <div class="main-content">
      <div class="tab-box">
        <div class="title-tab">账户中心</div>
        <div class="tab-list" v-for="(item, index) in tabArr" :key="index">
          <div
            :class="active === index ? 'tab-item-select' : 'tab-item'"
            @click="onTabClick(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div v-if="active === 0">
          <basic-information />
        </div>
        <div v-else-if="active === 1">
          <security-settings />
        </div>
        <div v-else-if="active === 2">
          <system-message />
        </div>
        <div v-else-if="active === 3">
          <login-log />
        </div>
        <div v-else-if="active === 4">
          <customer-service />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicInformation from "./components/basicinformation.vue";
import SecuritySettings from "./components/securitysettings.vue";
import SystemMessage from "./components/systemmessage.vue";
import LoginLog from "./components/loginlog.vue";
import CustomerService from "./components/customerservice.vue";
export default {
  name: "AccountCenter",
  components: {
    BasicInformation,
    SecuritySettings,
    SystemMessage,
    LoginLog,
    CustomerService,
  },
  data() {
    return {
      active: 0,
      tabArr: ["基本信息", "安全设置", "系统消息", "登录日志", "联系客服"],
    };
  },
  methods: {
    onTabClick(index) {
      this.active = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  background-color: #f6fafe;
  padding-top: 1px;
  padding-bottom: 1px;
  .main-content {
    width: 1320px;
    display: flex;
    justify-content: center;
    margin: 50px auto 100px;

    .tab-box {
      width: 260px;
      height: 650px;
      text-align: left;
      background: #ffffff;
      .title-tab {
        height: 60px;
        padding-left: 50px;
        background-color: #1082ff;
        line-height: 60px;
        font-size: 24px;
        font-weight: 700;
        color: #ffffff;
      }
      .tab-list {
        .tab-item,
        .tab-item-select {
          padding-left: 46px;
          height: 60px;
          font-size: 18px;
          color: #333333;
          line-height: 60px;
          border-left: 4px solid #ffffff;
          cursor: pointer;
        }
        .tab-item-select {
          color: #1082ff;
          border-left: 4px solid #1082ff;
        }
      }
    }
    .tab-content {
      margin-left: 20px;
      width: 1040px;
      height: 650px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/index.vue